// BEUS-11496 M3: 기존 dream-api `/es/get_heatmap_by_event` 응답을 v2 두 호출로 만든다.
//   좌표(heatmap·tabHeatmap·doubletabHeatmap) <- `/v2/heatmap/positions`
//   DOM 목록(dom·topClicks/topHovers/topTabs/topZooms·topPvs·metric·dailyClicks/dailyTabs) <- `/v2/heatmap/elements/screen`
//     (DOM 위치가 Mongo 좌표 문서에만 있어 api-hub가 기존 계산을 그대로 옮겨 만든다. app/helpers/heatmap/v2_elements_screen.py)
//
// 좌표 칸이 기존과 다르다(P0 D3 임시 채택: pixel-grid). 기존은 ES geohash_grid(precision 6) 칸 중심을 x·y로 쓰고,
// v2는 save_log 문서 좌표 그대로(click·move·tab 3px, doubletab·zoom 30px 반올림)다. 칸에 든 수의 합은 같다(음수 좌표 제외).
// 기존 화면 heatmap 그리기는 {x: {y: count}} 모양만 보므로 그대로 넣는다.

import { toV2Filters, toV2Range, unsupportedReason } from './request'

// 기존 event -> v2 positions eventTypes, 응답 key
const POSITION_TYPES = {
  click: [['click', 'heatmap']],
  move: [['move', 'heatmap']],
  tab: [['tab', 'tabHeatmap'], ['doubleTab', 'doubletabHeatmap']],
  zoomin: [['zoomIn', 'heatmap']],
  zoomout: [['zoomOut', 'heatmap']]
}

export function isSupportedHeatmapEvent (event) {
  return Object.prototype.hasOwnProperty.call(POSITION_TYPES, event)
}

function hasHour (params) {
  return params.hour !== undefined && params.hour !== null && params.hour !== ''
}

export function toV2HeatmapRequests (params, tzOffset = '+09:00') {
  const reason = unsupportedReason(params) || (isSupportedHeatmapEvent(params.event) ? null : 'event')
  if (reason) return { supported: false, reason }
  const base = {
    aid: params.aid,
    device: params.device,
    range: toV2Range(params, tzOffset),
    filters: toV2Filters(params)
  }
  return {
    supported: true,
    positions: { ...base, eventTypes: POSITION_TYPES[params.event].map(t => t[0]) },
    elements: { ...base, event: params.event, granularity: hasHour(params) ? 'hour' : 'day' }
  }
}

// v2 cells -> 기존 {x: {y: count}} (eventType별)
export function cellsToHeatmap (cells, eventType) {
  const out = {}
  for (const c of cells || []) {
    if (c.eventType !== eventType) continue
    if (!out[c.x]) out[c.x] = {}
    out[c.x][c.y] = (out[c.x][c.y] || 0) + c.count
  }
  return out
}

export function toLegacyHeatmapByEvent (event, positions, screen) {
  const out = {}
  for (const [type, key] of POSITION_TYPES[event]) {
    out[key] = cellsToHeatmap(positions.cells, type)
  }
  const meta = screen.v2 || {}
  for (const [k, v] of Object.entries(screen)) {
    if (k !== 'v2') out[k] = v
  }
  // 화면은 _v2를 읽지 않는다(비교·console 확인용).
  out._v2 = {
    dataVersion: positions.dataVersion,
    elementsDataVersion: meta.dataVersion,
    watermarkAt: positions.watermarkAt,
    truncatedCells: (positions.eventTypes || []).filter(t => t.truncated).map(t => t.eventType),
    excludedNegativeEvents: (positions.eventTypes || []).reduce((s, t) => s + t.excludedNegativeEvents, 0),
    truncatedElements: !!meta.truncatedElements
  }
  return out
}
